// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"556cdf6b","695":"238b81a9","750":"528ec3b8"}[chunkId] + ".chunk.js";
};